import { RouteDetails } from "../pages/LSummary";
import Truck from "./Icons/Truck";

export const TrackingSteps = ({
  location,
  truck,
  rail,
}: {
  location: string;
  truck: RouteDetails;
  rail: RouteDetails;
}) => {
  return (
    <div>
      <div className="w-[300px] p-2 border rounded-md space-y-2">
        <h3 className="text-gray-600 text-[16px] font-medium">{location}</h3>
        <div className="flex justify-between text-sm">
          <span className="flex gap-1"> <Truck/>
          <p className="text-custom-blue-new">Road FCL (By Truck)</p></span>
         
          <p>
            ~ {truck?.distance},{" "}
            {truck?.transitTime === "0" ? "0 days" : truck?.transitTime + " days"}
          </p>
        </div>
        <div className="flex justify-between my-1 text-sm">
          <p className="text-custom-blue-new">RF Road freight</p>
          <p>USD {truck?.price}</p>
        </div>

        {rail?.distance && rail?.price && rail?.transitTime && (
          <>
            <hr className="text-gray-100 my-1" />

            <div className="flex justify-between text-sm">
              
              <p className="text-custom-blue-new">Road FCL (By Rail)</p>
              <p>
                ~ {rail?.distance}, {rail?.transitTime +" days"}
              </p>
            </div>
            <div className="flex justify-between text-sm">
              <p className="text-custom-blue-new">RF Road freight</p>
              <p>USD {rail?.price}</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export function VerticalDividerWithCircle() {
  return (
    <div>
      <div className="h-5 w-5 border-[6px] border-custom-blue-new rounded-full mt-2" />
      <div className="w-0 h-24 border-2 border-custom-blue-new ml-2 mt-1" />
    </div>
  );
}
